export const RESET = 'DOCUMENT_TYPE_LIST_RESET'
export const SET_ITEMS = 'DOCUMENT_TYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'DOCUMENT_TYPE_LIST_SET_ERROR'
export const SET_VIEW = 'DOCUMENT_TYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'DOCUMENT_TYPE_LIST_TOGGLE_LOADING'
